import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useCallback } from 'react';
import { PRICING_DETAILS_PRODUCT_AREA } from './trackingConstants';

export const useTrackPersonalizedQuoteCTA = () => {
	const { track } = useAnalyticsContext();

	return useCallback(
		(location: 'Peak season' | 'Off-peak season') => {
			track({
				event: AnalyticsConstants.BUTTON_CLICKED,
				properties: {
					product_area: PRICING_DETAILS_PRODUCT_AREA,
					button_action: 'Get a personalized quote',
					location,
				},
			});
		},
		[track],
	);
};
